import React, { useState } from 'react';
import { Card, Row, Col, Form, Input, Button, Statistic, Divider, Progress, Tooltip, Table } from 'antd';
import { DollarCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';

const BudgetValidation = () => {
  // Sample data for multiple training requests
  const [budgets, setBudgets] = useState([
    {
      id: 1,
      trainingTitle: 'Full stack development',
      team: 'Data Science',
      requestedBy: 'Yessin Rebhi',
      submittedDate: '2024-09-27',
      environment: 5000,
      trainer: 3000,
      certification: 1000,
      logistics: 1500,
      totalBudget: 12000,
      allocatedBudget: 15000,
    },
    {
      id: 2,
      trainingTitle: 'Leadership Essentials',
      team: 'Management',
      requestedBy: 'Mohamed Koumenji',
      submittedDate: '2024-09-25',
      environment: 3000,
      trainer: 4000,
      certification: 800,
      logistics: 1200,
      totalBudget: 9000,
      allocatedBudget: 12000,
    },
    {
      id: 2,
      trainingTitle: 'Advanced Data Analysis',
      team: 'Management',
      requestedBy: 'Adem Naji',
      submittedDate: '2024-09-25',
      environment: 3000,
      trainer: 4000,
      certification: 800,
      logistics: 1200,
      totalBudget: 9000,
      allocatedBudget: 12000,
    },
  ]);

  const handleInputChange = (id, name, value) => {
    setBudgets((prevBudgets) =>
      prevBudgets.map((budget) =>
        budget.id === id ? { ...budget, [name]: parseFloat(value) || 0 } : budget
      )
    );
  };

  const validateBudget = (budget) => {
    const { totalBudget, allocatedBudget } = budget;
    const remainingBudget = allocatedBudget - totalBudget;

    return {
      isValid: remainingBudget >= 0,
      remainingBudget,
    };
  };

  const columns = [
    { title: 'Category', dataIndex: 'category', key: 'category' },
    { title: 'Allocated Amount ($)', dataIndex: 'amount', key: 'amount' },
    { title: 'Details', dataIndex: 'details', key: 'details' },
  ];

  const getCostBreakdownData = (budget) => [
    { key: '1', category: 'Environment', amount: budget.environment, details: 'Training venue, software licenses' },
    { key: '2', category: 'Trainer', amount: budget.trainer, details: 'External trainer fees, travel' },
    { key: '3', category: 'Certification', amount: budget.certification, details: 'Certification costs per participant' },
    { key: '4', category: 'Logistics', amount: budget.logistics, details: 'Accommodation, transport, meals' },
  ];

  return (
    <div>
      {budgets.map((budget) => {
        const budgetValidationResult = validateBudget(budget);

        return (
          <Card key={budget.id} title={`Budget Validation for ${budget.trainingTitle}`} style={{ marginBottom: '20px' }}>
            <Row gutter={16}>
              <Col span={12}>
                <Statistic title="Training Title" value={budget.trainingTitle} />
                <Statistic title="Requested By" value={budget.requestedBy} style={{ marginTop: '10px' }} />
              </Col>
              <Col span={12}>
                <Statistic title="Team" value={budget.team} />
                <Statistic title="Submitted Date" value={budget.submittedDate} style={{ marginTop: '10px' }} />
              </Col>
            </Row>
            <Divider />
            <Row gutter={16}>
              <Col span={6}>
                <Statistic title="Total Requested Budget" value={`$${budget.totalBudget}`} />
              </Col>
              <Col span={6}>
                <Statistic title="Allocated Budget" value={`$${budget.allocatedBudget}`} />
              </Col>
              <Col span={6}>
                <Statistic
                  title="Remaining Budget"
                  valueStyle={{ color: budgetValidationResult.isValid ? 'green' : 'red' }}
                  value={`$${budgetValidationResult.remainingBudget}`}
                />
              </Col>
              <Col span={6}>
                <Progress
                  percent={(budget.totalBudget / budget.allocatedBudget) * 100}
                  status={budgetValidationResult.isValid ? 'active' : 'exception'}
                  strokeColor={budgetValidationResult.isValid ? 'green' : 'red'}
                  format={(percent) => `${Math.floor(percent)}% Used`}
                />
              </Col>
            </Row>
            <Divider />
            <Card title="Detailed Budget Breakdown" style={{ marginBottom: '20px' }}>
              <Table columns={columns} dataSource={getCostBreakdownData(budget)} pagination={false} />
            </Card>
            <Card title="Adjust Budget Allocations">
              <Form layout="vertical">
                <Row gutter={16}>
                  <Col span={6}>
                    <Form.Item label="Environment ($)">
                      <Input
                        prefix={<DollarCircleOutlined />}
                        name="environment"
                        value={budget.environment}
                        onChange={(e) => handleInputChange(budget.id, 'environment', e.target.value)}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item label="Trainer ($)">
                      <Input
                        prefix={<DollarCircleOutlined />}
                        name="trainer"
                        value={budget.trainer}
                        onChange={(e) => handleInputChange(budget.id, 'trainer', e.target.value)}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item label="Certification ($)">
                      <Input
                        prefix={<DollarCircleOutlined />}
                        name="certification"
                        value={budget.certification}
                        onChange={(e) => handleInputChange(budget.id, 'certification', e.target.value)}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item label="Logistics ($)">
                      <Input
                        prefix={<DollarCircleOutlined />}
                        name="logistics"
                        value={budget.logistics}
                        onChange={(e) => handleInputChange(budget.id, 'logistics', e.target.value)}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Button type="primary" onClick={() => console.log('Budget updated')} block>
                  Update Budget
                </Button>
              </Form>
            </Card>
          </Card>
        );
      })}
    </div>
  );
};

export default BudgetValidation;
